import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AbstractWidgetComponent, AccountInfoService, ClientContextService, ConfigurationService, ContextChange, DialogService, HttpService, Identity, ResponseStatus, ServiceResponse, WidgetStyle } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { DialogLayout } from 'src/app/shared/dialog-layout/dialog-layout';
import { environment } from 'src/environments/environment';
import { PersonalVisitDetailsDialogComponent } from 'src/tmc-visit/components/personal-visit/component/personal-visit-details-dialog/personal-visit-details-dialog.component';
import { SupplementaryEquipmentHandoutComponent } from 'src/tmc-visit/components/supplementary-equipment-handout/component/supplementary-equipment-handout.component';
import { SupplementaryEquipmentTakeBackComponent } from 'src/tmc-visit/components/supplementary-equipment-take-back/component/supplementary-equipment-take-back.component';
import { Visit } from 'src/tmc-visit/tmc-visit.model';
import { PersonalVisitFilterModel } from '../../personal-visit-filter/personal-visit-filter.model';
import { InstructionsStatus, PersonalVisit, PersonalVisitStatus } from '../../personal-visit-list/personal-visit-list.model';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-personal-visit-action-bar',
  templateUrl: './personal-visit-action-bar.component.html',
  styleUrls: ['./personal-visit-action-bar.component.scss']
})
export class PersonalVisitActionBarComponent extends AbstractWidgetComponent implements OnInit {

  isAddEnabled = false;
  isRegisterEnabled = false;
  isEditEnabled = false;
  isDeleteEnabled = false;
  isLeaveEnabled = false;
  isHandoutSupplementaryEquipmentEnabled = false;
  isTakeBackSupplementaryEquipmentEnabled = false;

  resendInvitationEnabled = false;

  isPrintVisitorIdentityCardConfigured = false;
  isPrintVisitorIdentityCardEnabled = false;

  isCreateVisitorIdentityCardPDFEnabled = false;
  isEmergencyCallEnabled = true;

  filterModel = new PersonalVisitFilterModel();

  personalVisit: PersonalVisit;

  constructor(
    private tmcHttpService: HttpService,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private clientContextService: ClientContextService,
    private configurationService: ConfigurationService,
    public translationService: TranslationService,
    private accountInfoService: AccountInfoService
  ) {
    super();
  }

  ngOnInit(): void {
    const hardwareConnectorUrl = this.configurationService.getClientParam('clientproperty.visitors.print-identity-card.hardwareconnector');
    this.isPrintVisitorIdentityCardConfigured = hardwareConnectorUrl != null && hardwareConnectorUrl.value != null && hardwareConnectorUrl.value.trim() !== '';
    this.updateActionStatus();
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'selected-personal-visit') {
      this.personalVisit = contextChange.value;
      this.updateActionStatus();
    }

    if (contextChange.key === 'visitor-selection') {
      this.filterModel = contextChange.value;
    }
  }

  onSetElementAndContext() {
  }

  newPersonalVisitorVisit() {
    const visitorConfirmationDefault = this.configurationService.getClientParamValue('tmc-visit.control.visitor-confirmation-default', true) === 'true';
    const pv = new Visit({ confirmed: visitorConfirmationDefault});
    // pv.visitorType = VisitorType.VISITOR;

    this.dialogService.openMaxHeight(PersonalVisitDetailsDialogComponent,
      { model: pv, action: 'new', filterValue: this.filterModel.filterText }).afterClosed().subscribe(() => this.loadVisits());

  }

  editPersonalVisit() {
    const identity = { id: this.personalVisit.id };
    this.tmcHttpService.postWithContext<PersonalVisit>(environment.personalVisitEndpoint + '/details', identity).subscribe(result => {

      this.dialogService.openMaxHeight(PersonalVisitDetailsDialogComponent,
        { model: new Visit(result), action: 'edit' }).afterClosed().subscribe(() => this.loadVisits());

    });
  }

  registerEntranceForVisitReservation() {
    const identity = { id: this.personalVisit.id };
    this.tmcHttpService.postWithContext<PersonalVisit>(environment.personalVisitEndpoint + '/details', identity).subscribe(result => {

      this.dialogService.openMaxHeight(PersonalVisitDetailsDialogComponent,
        { model: new Visit(result), action: 'register-entrance' }).afterClosed().subscribe(() => this.loadVisits());

    });


  }

  leave() {
    const ident = { id: this.personalVisit.id };
    this.tmcHttpService.postWithContext<any>(environment.personalVisitEndpoint + '/checkLeave', ident).subscribe(r => {
      if (r.status === ResponseStatus.SUCCESS) {
        this.handleLeaveConfirm(ident);
      } else { // We expect, that we have warnings to display
        this.dialogService.showInfoDialog('tmc.personalvisit.dialog.leave.title',
          'tmc.personalvisit.dialog.leave.message.failed',
          r.responseMessages.map(m => m.dictionaryKey));
      }
    });
  }

  /** Opens a confirmation dialog the user must confirm the leave. */
  private handleLeaveConfirm(ident) {
    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc.personalvisit.dialog.leave.title',
      messageKey: 'tmc.personalvisit.dialog.leave.message',
      confirm: () => { this.executeLeave(ident); }
    };
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
  }

  /** Executed the actual leave of the visit. */
  private executeLeave(ident) {
    this.tmcHttpService.postWithContext<any>(environment.personalVisitEndpoint + '/leave', ident).subscribe(r => {
      if (r.status === ResponseStatus.SUCCESS) {
        this.loadVisits();
      } else {
        this.dialogService.showInfoDialog('tmc.personalvisit.dialog.leave.title',
          'tmc.personalvisit.dialog.leave.message.failed',
          r.responseMessages.map(m => m.dictionaryKey));
      }
    });
  }

  deletePersonalVisit() {
    const ident = { id: this.personalVisit.id };
    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc-visit.dialog.confirm-delete.title',
      messageKey: 'tmc-visit.dialog.confirm-delete.message',
      confirm: () => {
        this.executeDeletePersonalVisit(ident)
      }
    };
    this.dialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
  }

  private executeDeletePersonalVisit(ident) {
    this.tmcHttpService.postWithContext<any>(environment.personalVisitEndpoint + '/delete', ident).subscribe(r => {
      if (r.status === ResponseStatus.SUCCESS) {
        this.loadVisits();
      } else {
        this.dialogService.showInfoDialog('tmc.personalvisit.dialog.delete.title',
          'tmc.personalvisit.dialog.delete.message.failed',
          r.responseMessages.map(m => m.dictionaryKey));
      }
    });
  }

  private updateActionStatus() {
    const yard = this.clientContextService.getUnit();
    this.isAddEnabled = this.checkEditVisitEnabledForUser(yard.key);
    this.isEditEnabled = this.checkEditVisitEnabledForUser(yard.key) && this.personalVisit != null;
    this.isLeaveEnabled = this.checkLeaveVisitEnabledForUser(yard.key) && this.personalVisit != null && this.personalVisit.personalVisitStatus === PersonalVisitStatus.IN_PROCESS;
    this.isDeleteEnabled = this.checkDeleteVisitEnabledForUser(yard.key) && this.personalVisit != null && this.personalVisit.personalVisitStatus === PersonalVisitStatus.PLANNED;
    this.isRegisterEnabled = this.checkRegisterVisitEnabledForUser(yard.key) && this.personalVisit != null && this.personalVisit.personalVisitStatus === PersonalVisitStatus.PLANNED;
    this.resendInvitationEnabled = this.checkEditVisitEnabledForUser(yard.key) && this.personalVisit != null && this.personalVisit.personalVisitStatus === PersonalVisitStatus.PLANNED;
    this.isHandoutSupplementaryEquipmentEnabled = this.personalVisit != null;
    this.isTakeBackSupplementaryEquipmentEnabled = this.personalVisit != null;
    this.isPrintVisitorIdentityCardEnabled = this.personalVisit != null && this.personalVisit.instructionsStatus === InstructionsStatus.SUCCESSFUL;
    this.isCreateVisitorIdentityCardPDFEnabled = this.personalVisit != null;
  }

  private checkEditVisitEnabledForUser(yardKey: string): boolean {
    return this.accountInfoService.checkPrivilegeExistsForYardKey(yardKey, 'edit_visit');
  }

  private checkDeleteVisitEnabledForUser(yardKey: string): boolean {
    return this.accountInfoService.checkPrivilegeExistsForYardKey(yardKey, 'delete_visit');
  }

  private checkLeaveVisitEnabledForUser(yardKey: string): boolean {
    return this.accountInfoService.checkPrivilegeExistsForYardKey(yardKey, 'record_visitor_leave');
  }

  private checkRegisterVisitEnabledForUser(yardKey: string): boolean {
    return this.accountInfoService.checkPrivilegeExistsForYardKey(yardKey, 'record_visitor_entrance');
  }

  private loadVisits() {
    this.dashboardContext.setContextValue('personal-visit-changed', new Date().getTime());
  }

  public handoutSupplementaryEquipment() {
    if (!this.isHandoutSupplementaryEquipmentEnabled) {
      return;
    }
    const visitId = this.personalVisit.id;
    this.openHandoutSupplementaryEquipmentDialog(visitId, () => this.loadVisits());
  }

  public takeBackSupplementaryEquipment() {
    if (!this.isTakeBackSupplementaryEquipmentEnabled) {
      return;
    }
    const visitId = this.personalVisit.id;
    this.openTakeBackSupplementaryEquipmentDialog(visitId, () => this.loadVisits());
  }

  public openHandoutSupplementaryEquipmentDialog(visitId: number, callback: (result: any) => void) {

    const dialogRef = this.dialog.open(SupplementaryEquipmentHandoutComponent, {
      maxHeight: '95vh',
      data: { visitId: visitId },
      panelClass: DialogLayout.panelClass
    });

    dialogRef.afterClosed().subscribe(result => {
      callback(result);
    });
  }

  public openTakeBackSupplementaryEquipmentDialog(visitId: number, callback: () => any) {
    const dialogRef = this.dialog.open(SupplementaryEquipmentTakeBackComponent, {
      maxHeight: '95vh',
      data: { visitId: visitId },
      panelClass: DialogLayout.panelClass
    });

    dialogRef.afterClosed().subscribe(result => {
      callback();
    });
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

  public createVisitorIdentityCardPDF() {
    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'visitorIdentityCard');

    // keep focus in current window
    window.focus();
    const ident = { id: this.personalVisit.id };
    const url = `${environment.personalVisitEndpoint}/create-visitor-identity-card-pdf`;
    this.tmcHttpService.postWithArraybufferResponse<any>(url, ident).subscribe(result => {

      const file = new Blob([result], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow != null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }

  public resendInvitation() {
    const ident = { id: this.personalVisit.id };
    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc-visit.dialog.confirm-resend.title',
      messageKey: 'tmc-visit.dialog.confirm-resend.message',
      confirm: () => {
        this.executeResendInvitation(ident)
      }
    };
    this.dialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
  }

  private executeResendInvitation(ident) {
    const url = `${environment.personalVisitEndpoint}/resend-invitation`;
    this.tmcHttpService.postWithArraybufferResponse<any>(url, ident).subscribe(result => {
      return;
    }, error => {
      console.error(error);
    });
  }

  public printVisitorIdentityCard() {
    const hardwareConnectorUrl = this.configurationService.getClientParam('clientproperty.visitors.print-identity-card.hardwareconnector');
    if (hardwareConnectorUrl == null || hardwareConnectorUrl.value == null) {
      console.log('printVisitorIdentityCard: no hardwareconnector configured.');
      this.dialogService.showInfoDialog('tmc-visit.dialog.print-visitor-identity-card-error.title', 'tmc-visit.dialog.print-visitor-identity-card-error.message.no-printer');
    } else {
      console.log('printVisitorIdentityCard: hardwareconnector to use', hardwareConnectorUrl.value);
      const printData = this.createPrintModelVisitorIdentityCard(this.personalVisit);
      this.tmcHttpService.post<ServiceResponse>( hardwareConnectorUrl.value + '/io/printer/print', printData).subscribe(result => {
        console.log('print finished', result);
        if (result.status === ResponseStatus.SUCCESS) {
          const identity = new Identity();
          identity.id = this.personalVisit.id;
          this.tmcHttpService.postWithContext(environment.personalVisitEndpoint + '/log-visitor-identity-card-printing', identity).subscribe(result => {
            console.log('printing logged');
          });
        } else {
          console.log('print failed. reason:', result);
          this.dialogService.showInfoDialog('tmc-visit.dialog.print-visitor-identity-card-error.title', 'tmc-visit.dialog.print-visitor-identity-card-error.message.printer-error', result.responseMessages.map(msg => msg.defaultMessage));
        }
      },
      error => {
        console.log('print failed. reason:', error);
        this.dialogService.showInfoDialog('tmc-visit.dialog.print-visitor-identity-card-error.title', 'tmc-visit.dialog.print-visitor-identity-card-error.message.printer-not-reachable');
      });

    }

  }

  private createPrintModelVisitorIdentityCard(visit: PersonalVisit) {
    let validity = (visit.visitEnd == null || visit.start === visit.visitEnd)
                  ? DateTime.fromString(visit.start, 'dd.MM.yy hh:mm').toFormat('dd.MM.yy')
                  : (DateTime.fromString(visit.start, 'dd.MM.yy hh:mm').toFormat('dd.MM.yy') + ' - ' + DateTime.fromString(visit.visitEnd, 'dd.MM.yy hh:mm').toFormat('dd.MM.yy')) ;
    return {
        yardKey: visit.yardKey,
        type: 'VISITOR_IDENTITY_CARD',
        labels: {
          'label.name': this.translationService.translate('tmc-visit.entity.visit.name'),
          'label.company': this.translationService.translate('tmc-visit.entity.visit.company'),
          'label.numberPlate': this.translationService.translate('tmc-visit.entity.visit.numberplate'),
          'label.reason': this.translationService.translate('tmc-visit.entity.visit.reason'),
          'label.visitedPerson': this.translationService.translate('tmc-visit.print.visitor-identity-card.label.visited-person'),
          'label.validity': this.translationService.translate('tmc-visit.print.visitor-identity-card.label.validity'),
          'label.registrationFinished': this.translationService.translate('tmc-visit.entity.visit.start')

        },
        values: {
          name: visit.name,
          firstname : visit.firstname,
          company: visit.company,
          numberPlate: visit.numberPlate,
          reason: visit.reason,
          visitedPerson: visit.visitedPersonString,
          registrationFinished: DateTime.fromJSDate(new Date(visit.lastTerminalRegistrationDate)).toFormat("dd.MM.yyyy HH:mm"),
          validity: validity,
          qrCode: visit.registrationCode != null ? 'tmc-visit://visitor/' + visit.registrationCode : null
        }
      };
  }

  public emergencyCall() {
    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'emergency');

    // keep focus in current window
    window.focus();

    const url = `${environment.transportOverviewEndpoint}/ermergency-call`;

    this.tmcHttpService.postWithArraybufferResponse<any>(url, this.translationService.language).subscribe(result => {

      const file = new Blob([result], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }
}
